export default __webpack_public_path__ + "static/media/tekion-logo.65ea4c17.svg";